import 'lazysizes';
import JustValidate from 'just-validate';
import Headroom from "headroom.js";

import toastNotification from './modules/toastNotification';
import addToFavorites from './modules/favorites';
import { lazyLoadBackgrounds } from './modules/lazyLoadBackgrounds';

function modalToggle() {

  const openModalBtns = Array.from(document.querySelectorAll('[data-open-modal]'));

  openModalBtns.forEach(btn => {

    const modalID = `#${btn.dataset.openModal}`;

    btn.addEventListener('click', function (e) {

      e.preventDefault();
      const modal = document.querySelector(modalID);
      const htmlBody = document.querySelector('body');

      if (btn.dataset.videoSrc) {
        modal.querySelector('iframe').setAttribute('src', btn.dataset.videoSrc);
      }

      modal.classList.add('show');

      // this condition is for favorite button in header. It has two different roles on mob and desktop
      if (!btn.classList.contains('favorites') || window.innerWidth < 768) {
        htmlBody.style.overflow = 'hidden';
      }

      playVideo(modal);

      // Close modal if you click on backdrop layer
      modal.addEventListener('click', function closeModalWhenYouClickOutside(e) {
        if (e.currentTarget === e.target || e.target.contains(e.currentTarget)) {
          modal.classList.remove('show');
          htmlBody.style.overflow = 'auto';

          if (modal.dataset.modalRefresh) {
            location.reload();
          }
          pauseVideo(modal)
        }

        modal.removeEventListener('click', closeModalWhenYouClickOutside)
      })

      Array.from(modal.querySelectorAll('[data-close-modal]'))?.forEach(closeBtn => {
        closeBtn.addEventListener('click', function closeModal(e) {
          modal.classList.remove('show');
          htmlBody.style.overflow = 'auto';

          if (closeBtn.dataset.modalRefresh) {
            location.reload();
          }
          pauseVideo(modal)

          closeBtn.removeEventListener('click', closeModal)
        })
      })

    })

  });

}

function pauseVideo(videoModal) {
  if (videoModal.dataset.modalVideo == 'true') {
    videoModal.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }
}

function playVideo(videoModal) {
  if (videoModal.dataset.modalVideo == 'true') {
    setTimeout(function (e) {
      videoModal.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }, 1000);
  }
}

function validateContactForm() {

  const contactForm = document.querySelector("#contact-form");



  const validator = new JustValidate(contactForm, {
    validateBeforeSubmitting: true,
    focusInvalidField: true,
  });


  validator
    .addField(contactForm.querySelector('[name="first_name"]'), [
      {
        rule: 'required',
      }
    ])
    .addField(contactForm.querySelector('[name="last_name"]'), [
      {
        rule: 'required',
      }
    ])
    .addField(contactForm.querySelector('[name="email"]'), [
      {
        rule: 'required',
      },
      {
        rule: 'email',
        // errorMessage: 'This should be emaaaaail'
      },
    ])
    .addField(contactForm.querySelector('[name="message"]'), [
      {
        rule: 'required',
      }
    ]);




  contactForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const formData = new FormData(this);

    if (validator.isValid) {

    }

    validator.onSuccess((event) => {

      fetch('/index/sendEmail', {
        method: 'post',
        credentials: 'same-origin',
        mode: 'cors',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            toastNotification('Your message has been sent. Thank you.', 'success')
          }

          document.querySelector('#contact-form-modal [data-close-modal]').click()
        })
        .catch((error) => console.log('error', error))
    });


  })

  return validator
}

function toggleElements() {

  const toggleBtns = Array.from(document.querySelectorAll('[data-ad-toggle="toggler"]'));

  toggleBtns.forEach((btn) => {

    const targetID = btn.dataset.adTarget;
    const targetEl = document.querySelector(targetID);
    const targetElMaxHeight = Number(window.getComputedStyle(targetEl).maxHeight.split('px')[0]);

    if (btn.dataset.btn === 'read-more' && targetElMaxHeight >= targetEl.scrollHeight) {
      btn.style.display = 'none';
    } else {

      btn.addEventListener('click', (e) => {

        if (btn.tagName == 'A') {
          e.preventDefault();
        }

        if (targetEl) {
          btn.classList.toggle('active');
          targetEl.classList.toggle('active');
          targetEl.classList.contains('active') ? targetEl.style.maxHeight = `${targetEl.scrollHeight}px` : targetEl.style.maxHeight = null;
        }

        // for Read more btns
        if (btn.dataset.btn === 'read-more') {
          const btnTxt = btn.querySelector('span');


          if (btnTxt) {
            if (btn.classList.contains('active')) {
              btnTxt.textContent = 'Read less';
            } else {
              if (window.innerWidth < 768) {
                targetEl.scrollIntoView();
              }
              btnTxt.textContent = 'Read more'
            }

          }
        }

      })

    }

  })
}

function closeDropdownsWhenClickedOnBody(targetBtn, targetDropdown) {
  const body = document.querySelector('body');

  body.addEventListener('click', function clickEvent(e) {

    if (!e.target == targetBtn || !targetBtn.contains(e.target)) {
      targetBtn.classList.remove('active');
      targetDropdown?.classList.remove('active');
      body.removeEventListener('click', clickEvent)
    }
    if (!targetBtn.classList.contains('active')) {
      body.removeEventListener('click', clickEvent)
    }

  })
}

function toggleHeaderDropdowns() {

  Array.from(document.querySelectorAll('.toggle-btn')).forEach(function (wrapper) {

    wrapper.addEventListener('click', function (e) {
      let btn = wrapper.querySelector('.toggle-dropdown');
      let dropdown = wrapper.querySelector('.dropdown');

      // if (e.target === btn) {
      if (btn.contains(e.target)) {
        btn.classList.toggle('active');
        dropdown?.classList.toggle('active');
      }

      closeDropdownsWhenClickedOnBody(btn, dropdown)

    });
  })

}

function toggleHeaderDropdownMob(btn, dropdown) {

  btn?.addEventListener('click', function (e) {

    e.preventDefault();

    btn.classList.toggle('active');
    dropdown.classList.toggle('active');

    closeDropdownsWhenClickedOnBody(btn, dropdown, e.target)

  });
}

function addClassFocusOnFilledInputs() {
  Array.from(document.querySelectorAll('input, textarea'))
    .forEach(input => {

      input.addEventListener('keyup', function (e) {
        if (e.target.value.trim()) {
          e.target.classList.add('focus')
        } else {
          e.target.classList.remove('focus')

        }
      })
    })
}

function setCookies() {
  Array.from(document.querySelectorAll('[data-action="set-cookie"]'))
    .forEach(el => {

      el.addEventListener('click', function (e) {

        let cookieName = e.currentTarget.dataset.name;
        let cookieValue = e.currentTarget.dataset.value;

        if (document.cookie.indexOf(`${cookieName}=`) < 0) {
          document.cookie = cookieName + "=" + cookieValue + "; path=/;";
        }
      })
    })
}

function animateElements() {

  //add class on element with class animate-box when the element is visible
  const animateBox = Array.from(document.querySelectorAll('.animate-box'));

  // Animate on scroll
  window.addEventListener('scroll', function () {

    animateBox?.forEach(el => {
      let windowBottom = el.getBoundingClientRect().bottom;
      if (windowBottom - window.innerHeight <= 200) {
        el.classList.add('visible')
      }
    })

  })

  // ANimate on load
  const animateStats = Array.from(document.querySelectorAll('.animate-box.stats-wrapper'));
  animateStats?.forEach(stat => stat.classList.add('visible'))
}

function readMoreSectionsShowBtn() {
  const limitedDescSections = Array.from(document.querySelectorAll('.desc-section .desc.more'));
  limitedDescSections.forEach(section => {

    if (section.offsetHeight < section.querySelector('.inner').offsetHeight) {
      section.nextElementSibling.classList.add('show')
    }
  });
}

function switchTabs() {
  document.querySelectorAll('[data-tab-group]').forEach(group => {

    const groupTabs = group.querySelectorAll('[data-ad-tab]');

    groupTabs.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-ad-target');

        group.querySelectorAll('[data-ad-tab]').forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        group.querySelectorAll('[data-ad-content]').forEach(tab => tab.classList.remove('active'));
        group.querySelector(`[data-ad-content="${tabId}"]`).classList.add('active');
      });
    })

  });
}

// Headroom show/hide header
function headroomToggle() {
  let myElement = document.querySelector('header');
  let headroom = new Headroom(myElement);
  headroom.init();
}

function togglePasswordVisibility() {
  Array.from(document.querySelectorAll('[data-widget="password-visibility"]'))
    .forEach(box => {

      const icon = box.querySelector('svg');
      const input = box.querySelector('input[type="password"]');

      icon?.addEventListener('click', function (e) {
        if (input.getAttribute('type') === 'password') {
          input.setAttribute('type', 'text')
        } else {
          input.setAttribute('type', 'password')
        }
      })

    });
}

function toggleMobSearch(){
   document.querySelector('#searchToggleBtn').addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector('#mobSearchForm').classList.toggle('expanded');
    });
}

function toggleMobileMenuElements(){

  Array.from(document.querySelectorAll('.toggle-first-level')).forEach(function (toggler) {
    toggler.addEventListener('click', function (e) {
        let li_target = toggler.closest('li');

        const first_level_lis = Array.from(document.querySelectorAll('.mobile-nav li.first-level-holder'));
        first_level_lis?.forEach(function (li) {
            if(li != li_target){
                li.classList.remove('Expanded');
            }
        });
        
        toggler.classList.toggle('Expanded')
        li_target.classList.toggle('Expanded');
    });
  })

  Array.from(document.querySelectorAll('.toggle-sec-level')).forEach(function (toggler) {
    toggler.addEventListener('click', function (e) {
        let section_target = toggler.closest('section');

        const sections = Array.from(document.querySelectorAll('.mobile-nav section'));
        sections?.forEach(function (sec) {
            if(sec != section_target){
                sec.classList.remove('Expanded');
            }
            
        });
        
        toggler.classList.toggle('Expanded')
        section_target.classList.toggle('Expanded');
    });
  })
}

function oneTimeToastrNotifications() {
  if (window.__ONE_TIME_TOASTR) {
      toastNotification(
          window.__ONE_TIME_TOASTR.text,
          window.__ONE_TIME_TOASTR.type
      );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  addToFavorites();
  modalToggle();
  validateContactForm();
  toggleElements();
  toggleHeaderDropdowns();
  setCookies();
  headroomToggle();
  addClassFocusOnFilledInputs();
  togglePasswordVisibility();
  readMoreSectionsShowBtn();
  lazyLoadBackgrounds('[data-bgimage');
  animateElements();
  switchTabs();
  toggleMobSearch();
  oneTimeToastrNotifications();

  if (window.innerWidth < 1024) {
      toggleMobileMenuElements();

    // toggleHeaderDropdownMob(document.querySelector('nav .profile.logged'), document.querySelector('.prof .dropdown'))
    // toggleHeaderDropdownMob(document.querySelector('nav .shorlists'), document.querySelector('.favorites .dropdown'))
  }
});